import Const from "../const";

let image = {};
const skinType = Const.skinType.toUpperCase();

if (skinType === "GOGOIT") {
    image = {
        onBtnIcon: require('../img/body/gogoit_onbtn.png'),
        offBtnIcon: require('../img/body/gogoit_offbtn.png'),
        headerLogo: require('../img/header/gogoit_header_logo.png'),
        headerLogoM02: require('../img/header/gogoit_header_logo-m-02.png'),
        chatOnIcon: require('../img/header/chat-on.png'),
        chatOffIcon: require('../img/header/chat-off.png'),
        deliveryOnIcon: require('../img/body/gogoit_delivery-on.png'),
        deliveryIcon: require('../img/body/gogoit_delivery.png'),
        headerDeliveryIcon: require('../img/header/gogoit_header_delivery.png'),
        pickupOnIcon: require('../img/body/gogoit_pickup-on.png'),
        pickupIcon: require('../img/body/gogoit_pickup.png'),
        paymentOnIcon: require('../img/body/gogoit_payment-on.png'),
        paymentIcon: require('../img/body/gogoit_payment.png'),
        settingOnIcon: require('../img/body/gogoit_setting-on.png'),
        settingIcon: require('../img/body/gogoit_setting.png'),
        mainIcon: require('../img/header/gogoit_header_main.png'),
        calculateIcon: require('../img/header/gogoit_header_calculate.png'),
        headerSettingIcon: require('../img/header/gogoit_header_setting.png'),
        headerLogoutIcon: require('../img/header/logout.png'),
        logoutIcon: require('../img/body/logout.png'),
        resetIcon: require('../img/keyboard/reset.png'),
        closeIcon: require('../img/body/close.png'),
        shopIcon: require('../img/header/shop.png'),
        MarkerTargetIcon: require('../img/map/gogoit_marker_target.png'),
        MarkerRiderIcon: require('../img/map/gogoit_marker_rider.png'),
        FranchiseColorIcon: require('../img/map/gogoit_franchise.png'),
        SearchIcon: require('../img/body/gogoit_search.png'),
        MapIcon: require('../img/body/gogoit_map.png'),
        StarIcon: require('../img/body/gogoit_star2.png'),
        Star2Icon: require('../img/body/star2.png'),
        ChatDefaultIcon: require('../img/body/gogoit_chat.png'),
        LeftBtn3Icon: require('../img/body/gogoit_leftbtn3.png'),
        KeyboardIcon: require('../img/body/gogoit_keyboard.png'),
        DownloadIcon: require('../img/body/gogoit_download.png'),
        SelectIcon: require('../img/body/gogoit_select.png'),
        UnselectIcon: require('../img/body/unselect.png'),
        InputIdIcon: require('../img/input_id.png'),
        InputPwIcon: require('../img/input_pw.png'),
        ChargeIcon: require('../img/body/marketing.png'),
        CallIcon: require('../img/body/call.png'),
        MarketingIcon: require('../img/body/marketing.png'),
        PeristIcon: require('../img/body/perist.png'),
        SettingKeyboardIcon: require('../img/body/setting_keyboard.png'),
        LinkIcon: require('../img/body/link.png'),
        BackspaceIcon: require('../img/keyboard/backspace.png'),
        ResetIcon: require('../img/keyboard/reset.png'),
        LeftBtn1Icon: require('../img/body/gogoit_leftbtn1.png'),
        LeftBtn2Icon: require('../img/body/gogoit_leftbtn2.png'),
        RightBtn1Icon: require('../img/body/gogoit_rightbtn1.png'),
        RightBtn2Icon: require('../img/body/gogoit_rightbtn2.png'),
    }
} else {
    image = {
        onBtnIcon: require('../img/body/onbtn.png'),
        offBtnIcon: require('../img/body/offbtn.png'),
        headerLogo: require('../img/header/header_logo.png'),
        headerLogoM02: require('../img/header/header_logo-m-02.png'),
        chatOnIcon: require('../img/header/chat-on.png'),
        chatOffIcon: require('../img/header/chat-off.png'),
        deliveryOnIcon: require('../img/body/delivery-on.png'),
        deliveryIcon: require('../img/body/delivery.png'),
        headerDeliveryIcon: require('../img/header/delivery.png'),
        pickupOnIcon: require('../img/body/pickup-on.png'),
        pickupIcon: require('../img/body/pickup.png'),
        paymentOnIcon: require('../img/body/payment-on.png'),
        paymentIcon: require('../img/body/payment.png'),
        settingOnIcon: require('../img/body/setting-on.png'),
        settingIcon: require('../img/body/setting.png'),
        mainIcon: require('../img/header/main.png'),
        calculateIcon: require('../img/header/calculate.png'),
        headerSettingIcon: require('../img/header/setting.png'),
        headerLogoutIcon: require('../img/header/logout.png'),
        logoutIcon: require('../img/body/logout.png'),
        resetIcon: require('../img/keyboard/reset.png'),
        closeIcon: require('../img/body/close.png'),
        shopIcon: require('../img/header/shop.png'),
        MarkerTargetIcon: require('../img/map/marker_target.png'),
        MarkerRiderIcon: require('../img/map/marker_rider.png'),
        FranchiseColorIcon: require('../img/map/franchise_yellow.png'),
        SearchIcon: require('../img/body/search.png'),
        MapIcon: require('../img/body/map.png'),
        StarIcon: require('../img/body/star.jpg'),
        Star2Icon: require('../img/body/star2.png'),
        ChatDefaultIcon: require('../img/body/chat_default.png'),
        LeftBtn3Icon: require('../img/body/leftbtn2.png'),
        KeyboardIcon: require('../img/body/keyboard.png'),
        DownloadIcon: require('../img/body/download.png'),
        SelectIcon: require('../img/body/select.png'),
        UnselectIcon: require('../img/body/unselect.png'),
        InputIdIcon: require('../img/input_id.png'),
        InputPwIcon: require('../img/input_pw.png'),
        ChargeIcon: require('../img/body/marketing.png'),
        CallIcon: require('../img/body/call.png'),
        MarketingIcon: require('../img/body/marketing.png'),
        PeristIcon: require('../img/body/perist.png'),
        SettingKeyboardIcon: require('../img/body/setting_keyboard.png'),
        LinkIcon: require('../img/body/link.png'),
        BackspaceIcon: require('../img/keyboard/backspace.png'),
        ResetIcon: require('../img/keyboard/reset.png'),
        LeftBtn1Icon: require('../img/body/leftbtn1.png'),
        LeftBtn2Icon: require('../img/body/leftbtn2.png'),
        RightBtn1Icon: require('../img/body/rightbtn1.png'),
        RightBtn2Icon: require('../img/body/rightbtn2.png'),
    }
}

export default image;
